/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ContentRecord,
  GeneratedContentDetails,
  Tool,
} from '@cyborg-monorepo/hunter/common';
import { categories, SupportedTools } from '@cyborg-monorepo/hunter/matchboi';
import Mark from 'mark.js';
import {
  getSearchURLForContent,
  getToolIcon,
  supportedToolUrl,
} from '../../../../helpers/utils';
import { SearchStateService } from '../../../research/services/search-state.service';
import { MarkCopiedComponent } from '../cyborg-snackbar/cyborg-snackbar';

@Component({ standalone: false, 
  selector: 'cyborg-environment-content',
  templateUrl: './cyborg-environment-content.component.html',
  styleUrls: ['./cyborg-environment-content.component.scss'],
})
export class CyborgEnvironmentContentComponent
  implements OnInit, AfterViewInit
{
  @Input() public environment: any;
  public onOpenContentDrawer: EventEmitter<void> = new EventEmitter<void>();
  public compatible: boolean;
  public contentDetails: ContentRecord;
  public generatedContentDetails: GeneratedContentDetails;
  public generatedAddtionalContentDetails: Array<GeneratedContentDetails> = [];
  public selectedTool: any;
  public incompat: number = 0;
  public partial: number = 0;
  public compat: number = 0;
  public getToolIcon = getToolIcon;

  constructor(
    private myElement: ElementRef,
    private searchStateService: SearchStateService,
    private snackBarService: MatSnackBar,
  ) {}

  public ngOnInit(): void {
    this.selectedTool = this.environment.tools[0];

    this.incompat = this.environment.tools.filter((tool) => {
      return (
        tool.compatible == 0 ||
        tool.generatedContent?.length == 0 ||
        (tool.generatedContent?.Hunt?.length == 0 &&
          tool.generatedContent?.Behavior?.length == 0)
      );
    }).length;

    this.compat = this.environment.tools.filter((tool) => {
      return (
        tool.compatible ==
        tool.generatedContent?.Hunt?.length +
          tool.generatedContent?.Behavior?.length
      );
    }).length;

    this.partial = this.environment.tools.filter((tool) => {
      return (
        tool.compatible != 0 &&
        tool.compatible <
          tool.generatedContent?.Hunt?.length +
            tool.generatedContent?.Behavior?.length
      );
    }).length;
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.textHightlighting();
    }, 0);
  }

  public openContentDetails(): void {
    this.onOpenContentDrawer.emit();
  }

  public populateContent(tool): void {
    this.selectedTool = tool;
  }

  public onOpen(target: HTMLElement): void {
    const huntPackage =
      target.parentElement.parentElement.parentElement.parentElement;
    huntPackage.classList.toggle('is-opened');
  }

  public onCopy(target: EventTarget): void {
    const text = (target as HTMLElement).parentNode as HTMLElement;
    navigator.clipboard.writeText(
      text.getElementsByTagName('pre')[0].textContent,
    );
    this.snackBarService.openFromComponent(MarkCopiedComponent, {
      duration: 5 * 1000,
    });
  }

  /**
   * Builds the Tool URI based on the contentTool selected and the content of the record
   */
  public getSearchURLForContent(tool: Tool, content: string): string {
    return getSearchURLForContent(tool, content);
  }

  /**
   * Checks current generated tool against list of supported automated link tools
   * returns boolean
   */
  public supportedTool(contentTool: SupportedTools): boolean {
    return supportedToolUrl(contentTool);
  }

  /**
   * Return readable version of default CCM category if it exists, otherwise return user's custom category
   */
  public getReadableCategory(category: string): string {
    return categories[category]?.name ? categories[category].name : category;
  }

  private textHightlighting(): void {
    const context =
      this.myElement.nativeElement.querySelectorAll('p, content-title');
    const instance = new Mark(context);
    const term = this.searchStateService.state.value.term;
    if (term) {
      instance.mark(term, {
        element: 'em',
        className: 'highlight',
      });
    }
  }
}
